import React from "react";
import { Link } from "react-router-dom";

interface AuthLinkProps {
  to: string;
  text: string;
  linkText: string;
}

const AuthLink: React.FC<AuthLinkProps> = ({ to, text, linkText }) => {
  return (
    <div className="auth-link-text">
      <span>{text} </span>
      <Link to={to}>{linkText}</Link>
    </div>
  );
};

export default AuthLink;



